<template>
  <div>
    <v-text-field
      v-model="search"
      class="search-input"
      label="Поиск"
      single-line
      color="accent"
      hide-details
      @keypress.enter="searchRound"
    >
      <template #append-outer>
        <v-icon class="icon" style="font-size: 18px" @click="searchRound">fas fa-check</v-icon>
        <v-icon class="icon" @click="cancelSearch">fas fa-times</v-icon>
      </template>
    </v-text-field>
    <paginated-table
      :items="searchRounds.length === 0 ? items : searchRounds"
      :headers="headers"
      :loading="loading"
      :pullFunction="getRounds"
    >
      <template #items="props">
        <mines-statisctics-item :item="props.item" />
      </template>
    </paginated-table>
  </div>
</template>

<script>
import PaginatedTable from '../../../PaginatedTable'
import { getStatisticsRoundsMines } from '../../../../../api/mines'
import MinesStatiscticsItem from './MinesStatisticsItem'

export default {
  name: 'MinesStatisticsTable',
  components: { MinesStatiscticsItem, PaginatedTable },
  data () {
    return {
      items: [],
      searchRounds: [],
      search: '',
      loading: false,
      pagination: {
        sortBy: 'timestart',
        descending: true
      },
      headers: [
        { text: 'id игры', value: 'game_id' },
        { text: 'Ставка', value: 'bet' },
        { text: 'id польз.', value: 'user_id' },
        { text: 'Открытые ячейки', value: 'opened_cells' },
        { text: 'Количество бомб', value: 'mines_count' },
        { text: 'Коэф.', value: 'factor' },
        { text: 'Выигрыш', value: 'prize' },
        { text: 'Дата', value: 'created_at' }
      ]
    }
  },
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  mounted () {
    this.getRounds(1)
  },
  methods: {
    searchRound () {
      this.loading = true
      getStatisticsRoundsMines({
        limit: 25, offset: 0, game_id: this.search
      }).then(response => {
        this.searchRounds = response.data.items.map(i => {
          i.opened_cells = i.opened_cells.length
          return i
        })
        if (this.searchRounds.length === 0)
          this.$store.dispatch('showErrorMessage', 'Раунд не найден')

        this.loading = false
      })
        .catch(error => {
          this.loading = false
          console.log(error)
          this.$store.dispatch('showErrorMessage', 'Ошибка')
        })
    },
    cancelSearch () {
      this.search = ''
      this.searchRounds = []
    },
    getRounds (page) {
      getStatisticsRoundsMines({ limit: 26, offset: (page - 1) * 25 }).then(response => {
        this.items = response.data.items.map(i => {
          i.opened_cells = i.opened_cells.length
          return i
        })
      })
    }
  }
}
</script>

<style scoped>
    .icon {
        cursor: pointer;
        font-size: 20px;
        padding: 2px 4px;
    }

    .icon:hover {
        background: #eeeef4;
        border-radius: 4px;
    }

    .search-input {
        flex: none;
        width: 30%;
        margin-left: auto;
        margin-bottom: 10px;
    }
</style>
